__turbopack_context__.v({
  "icon": "tooltip-module-scss-module__DrpiBq__icon",
  "tooltip": "tooltip-module-scss-module__DrpiBq__tooltip",
});
